import Phaser from 'phaser';
import { SnakeGameScene } from './scenes/SnakeGameScene';
import { MenuScene } from './scenes/MenuScene';
import { InstructionsScene } from './scenes/InstructionsScene';
import { LeaderboardScene } from './scenes/LeaderboardScene';
import { ConfigScene } from './scenes/ConfigScene';


const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#000000',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    // no fixed width/height: canvas resizes to the container (Reddit window)
  },
  scene: [MenuScene, SnakeGameScene, InstructionsScene, LeaderboardScene, ConfigScene],
};

function startGame() {
  // eslint-disable-next-line no-new
  new Phaser.Game(config);
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  startGame();
} else {
  document.addEventListener('DOMContentLoaded', startGame);
}
